module.exports = __webpack_public_path__ + "media/images/icons/bandcamp-2d715d97cdcdfb8dd435f7ce6bf0285a.svg";